export default __webpack_public_path__ + "c1bb262d2349f221620e648a4953bd35.png";